import { FC } from 'react'

import { useBankPortalContext } from 'bank-portal-context'
import { IconName, Tooltip } from 'ui/components'

import { MainBarLogo } from '../Logo'
import { NeedHelpMenu } from '../NeedHelpMenu'

import * as SC from './styles'

export const Bar: FC<{
  minimized: boolean
  children: React.ReactNode
  onToggleBar: () => void
}> = ({ minimized, children, onToggleBar }) => {
  const {
    isOnlyApplicationsAndAccountSettingsAccessible,
    layout: { nextCloudRedirectURL }
  } = useBankPortalContext()

  return (
    <SC.BarContainer minimized={minimized}>
      <SC.BarHeaderContainer>
        <SC.MenuToggleIcon onClick={onToggleBar} name={minimized ? IconName.MENU_MINIMIZED : IconName.MENU} />
        <MainBarLogo linkForLogo={'/'} isMinimized={minimized} />
      </SC.BarHeaderContainer>
      <SC.BarContent>{children}</SC.BarContent>
      <SC.Footer>
        <SC.HelpButton>
          <NeedHelpMenu>
            <SC.HelpButtonContent>
              <SC.ButtonsIcon name={IconName.CHAT_BUBBLE_QUESTION} />
              {!minimized && <SC.HelpLabel $minimized={minimized}>Need help?</SC.HelpLabel>}
            </SC.HelpButtonContent>
          </NeedHelpMenu>
        </SC.HelpButton>

        {!minimized && !isOnlyApplicationsAndAccountSettingsAccessible && (
          <SC.NextCloudButton $minimized={minimized}>
            <Tooltip id="next-cloud-tooltip" type="dark" place="right" content="Share files">
              <SC.ButtonsIcon name={IconName.NEXT_CLOUD} onClick={() => window.open(nextCloudRedirectURL)} />
            </Tooltip>
          </SC.NextCloudButton>
        )}
      </SC.Footer>
    </SC.BarContainer>
  )
}
